import script from "./pointsMall.vue?vue&type=script&setup=true&lang=js"
export * from "./pointsMall.vue?vue&type=script&setup=true&lang=js"

import "./pointsMall.vue?vue&type=style&index=0&id=c575a8ac&lang=scss"

const __exports__ = script;

export default __exports__